//부서 조회 팝업
<template>
	<sf-modal-layout size="s" :title="getMessage_('QWCC001874')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100" v-if="isLoaded">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" :scrId="scrId" @Refresh="reload"></search-view>
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-view ref="tableView" @close="close" @Refresh="reload" @SelectRow="selectRow" :scrId="scrId"></table-view>
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/DeptMngPopup/store/helpers';
import SearchView from './Content/Search/Search.vue';
import TableView from './Content/Table/Table.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchView, TableView },
	data() {
		return {
			show: false,
			isLoaded: false
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		selectRow(row) {
			this.$emit('SendData', row);
			this.close();
		},
		open(param) {
			this.$sf_toggleLoading(true);
			this.isLoaded = false;
			this.show = true;
			this.setStateInit_();
			this.setSearchParam_({ key: 'deptNm', value: param });
			try {
				this.reload();
			} catch (error) {
				console.error(error);
			} finally {
				this.$sf_toggleLoading(false);
				this.isLoaded = true;
			}
		},
		close() {
			this.setStateInit_();
			this.isLoaded = false;
			this.show = false;
		},
		reload() {
			this.$refs.searchView?.searchList();
		}
	}
};
</script>

<style></style>
